import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UtilService } from "@app/modules/shared/services/util.service";

@Component({
  selector: "kl-form-container",
  templateUrl: "./form-container.component.html",
  styleUrls: ["./form-container.component.scss"],
})
export class FormContainerComponent {
  @Input() mode: string;
  @Input() title: string;
  @Input() pageId: string;
  @Input() alertType: string;
  @Input() alertMessage: string;
  @Input() alertShow: boolean;
  @Input() saveAndNew = true;
  @Input() processButtons: Array<{
    method: Function;
    show: boolean;
    slug: string;
    icon: string;
    children: Array<{ slug: string; method: Function }>;
  }>;
  @Input() buttons: Array<{
    method: Function;
    show: boolean;
    slug: string;
    icon: string;
    children: Array<object>;
  }>;

  @Output() onCommitSave = new EventEmitter();
  @Output() onCloseAlert = new EventEmitter();
  @Output() onSaveTemplate = new EventEmitter();

  constructor(private utilService: UtilService) {}

  commitSave(type?: string) {
    this.onCommitSave.emit(type ? type : null);
  }

  // commitSave(type?: string) {
  //     let save = false;
  //     if (this.mode === 'add') {
  //         save = this.utilService.isShow(this.pageId + '.001');
  //     } else if (this.mode === 'copy') {
  //         save = this.utilService.isShow(this.pageId + '.001');
  //     } else if (this.mode === 'edit') {
  //         save = this.utilService.isShow(this.pageId + '.002');
  //     }
  //     if (save) {
  //         this.onCommitSave.emit(type ? type : null);
  //     } else {
  //         this.alertMessage = 'not_authorized_to_perform_this_operation';
  //         this.alertShow = true;
  //         this.alertType = 'error';
  //     }
  // }

  closeAlert() {
    this.onCloseAlert.emit();
  }

  saveTemplate() {
    this.onSaveTemplate.emit();
  }
}
